<template>
  <div class="font-selector">
    <el-popover
      v-model:visible="visible"
      trigger="click"
      placement="bottom-start"
      :width="300"
      :hide-after="0"
      :show-arrow="false"
      popper-class="font-popover"
    >
      <template #reference>
        <div class="font-selector__trigger">
          <span>{{ fontLabel }}</span>
          <SvgIcon name="editor-chevron-down" :size="14" color="#94A3B8" />
        </div>
      </template>
      <template #default>
        <FontListPanel v-if="visible" v-model="fontFamily" />
      </template>
    </el-popover>
  </div>
</template>

<script setup lang="ts">
  import FontListPanel from './FontListPanel.vue';
  import SvgIcon from '@/components/common/icon/SvgIcon.vue';
  import { computed, ref } from 'vue';
  import { useFontStore } from '@/store';

  const fontFamily = defineModel<string>();

  const fontStore = useFontStore();
  const visible = ref(false);

  const fontLabel = computed(() => {
    return fontStore.getFontLabel(fontFamily.value ?? '') || '默认字体';
  });
</script>

<style>
  .font-popover {
    --el-popover-padding: 0px !important;
    border: 1px solid #e5e7eb !important;
    border-radius: 8px !important;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.12) !important;
  }
</style>

<style scoped>
  .font-selector {
    width: 100%;
    flex: 1;
    min-width: 0;
  }

  .font-selector__trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    height: 36px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    cursor: pointer;
    transition: border-color 0.2s;
    box-sizing: border-box;
    background: #fff;
  }

  .font-selector__trigger:hover {
    border-color: #6033e1;
  }

  .font-selector__trigger span {
    font-weight: 500;
    font-size: 13px;
    color: #374151;
  }
</style>
